module.exports = __webpack_public_path__ + "img/aeroplano.54742571.png";